// extracted by mini-css-extract-plugin
export var contentBody = "_dg-9";
export var headerImage = "_dg-2";
export var imageButton = "_dg-7";
export var imageButtonIcon = "_dg-8";
export var imageHeader = "_dg-4";
export var imageHeaderText = "_dg-5";
export var imageOverlay = "_dg-3";
export var imageTitle = "_dg-6";
export var imageWrapper = "_dg-1";
export var taskList = "_dg-a";
export var widget = "_dg-0";